import { Col, Row, Carousel, Skeleton } from "antd";
import { GetBannerAxios } from './ajax'
import React, { useEffect, useRef, useState } from "react"

export function SlideBanner(props) {
  const [banner, setBanner] = useState({})
  const [phbanner, setPhbanner] = useState({})
  const [loading, setLoading] = useState(false)
  const imgbox = useRef()

  document.onreadystatechange = function subSomething() {
    if (document.readyState !== "complete") {
      setLoading(true)
    }
    setLoading(false)
  }
  const prev = () => {
    imgbox && imgbox.current.prev()
  }
  const next = () => {
    imgbox && imgbox.current.next()
  }
  const reload = async () => {
    let res = await GetBannerAxios()
    if (res.code !== 0) {
      console.log(res.message)
      return
    }
    else {
      let filterData = res.data.filter(i => i.device * 1 === 0)
      let filterData2 = res.data.filter(i => i.device * 1 === 1)
      setBanner(filterData)
      setPhbanner(filterData2)

    }
  }
  useEffect(() => {

    reload()
  }, [])
  let settings = {
    autoplay: true,
    arrows: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    dots: true,
    adaptiveHeight: true
  }
  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <div className="content-top-img-pc">
          <div className="slide-box">
            <div className="to-arrow">
              <div className="arrows" onClick={() => { prev() }}></div>
              <div className="right-arrows" onClick={() => { next() }}></div>
            </div>
            <Carousel className="fixed-size" {...settings} ref={imgbox} dotsClass="slick-dots" style={{ position: "relative" }} >
              {banner && banner.length > 0 ? banner.sort((a, b) => b.sort - a.sort).map(item => {
                return (
                  <div className="addhand" key={item.id}><img onClick={() => {
                    if (item.isTarget) {
                      window.open(item.target)
                    } else {
                      if (item.target) {
                        window.location.href = item.target
                      }
                    }
                  }} style={{ display: "block", minWidth: '1440px' }} width="100%" height="100%" src={item.url} alt="加载中" /></div>
                )
              }) : null}
            </Carousel>
          </div>

        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <div className="content-top-img">
          <div>
            <Carousel {...settings} className="fixed-size">
              {phbanner && phbanner.length > 0 ? phbanner.sort((a, b) => b.sort - a.sort).map(i => {
                return (
                  <div key={i.id} className="ajust-padding">
                    {loading ?
                      <Skeleton.Image /> : <img onClick={() => {
                        if (i.isTarget) { window.open(i.target) }
                        else {
                          if (i.target) { window.location.href = i.target }
                        }
                      }} src={i.url} height="100%" alt="加载中" />}
                  </div>
                )
              }) : null}
            </Carousel>
          </div>
        </div>
      </Col>
    </Row>
  )
}